import axios from "axios";
import moment from 'moment';

import { config } from "../../config";
import { State } from '../../entity/location/state';
import { StateTransformer } from '../transformers/address';

export class LocationService {
    async states(): Promise<State[]> {        
        let response = await axios.get(config.api.host + "/states")
        let statesInfos: any[] = response.data.data
        let states: State[] = []
        statesInfos.forEach(stateInfo => {           
            states.push(new StateTransformer().transform(stateInfo))
        });
        return Promise.resolve(states)
    }
}